export default "__VITE_ASSET__pjDCvNVS__"